// Auto-CC internal staff chips shown in the quote/PO send dialogs (Trent, Nov 2026).
// Staff can remove a CC for this send only — the saved defaults are untouched.
import { X } from "lucide-react";

export function AutoCcChips({ cc, onRemove, testPrefix = "autocc", toEmails = [] }) {
  if (!cc || cc.length === 0) return null;
  const toSet = new Set(toEmails.map((e) => (e || "").toLowerCase()));
  return (
    <div className="pt-1 border-t border-slate-200">
      <span className="text-slate-500 uppercase tracking-wider text-[10px] font-semibold">CC — internal staff (auto)</span>
      <div className="mt-1 flex flex-wrap gap-1.5" data-testid={`${testPrefix}-list`}>
        {cc.map((u) => {
          const dup = toSet.has((u.email || "").toLowerCase());
          return (
          <span key={u.email}
            title={dup ? "Already a To recipient — won't be CC'd" : undefined}
            className={`inline-flex items-center gap-1.5 border rounded-full px-2.5 py-0.5 text-[11px] font-medium ${dup ? "bg-slate-50 border-slate-200 text-slate-400 line-through" : "bg-cyan-50 border-cyan-200 text-cyan-800"}`}
            data-testid={`${testPrefix}-chip-${u.email}`}>
            {u.name || u.email}
            <button type="button" title="Remove CC for this send only"
              className={`${dup ? "text-slate-300" : "text-cyan-500"} hover:text-rose-600`}
              onClick={() => onRemove(u.email)}
              data-testid={`${testPrefix}-remove-${u.email}`}>
              <X size={10} />
            </button>
          </span>
          );
        })}
      </div>
      <div className="text-[10px] text-slate-400 mt-1">Removing a person here only applies to this send — the saved auto-CC list is unchanged.</div>
    </div>
  );
}
